import '@/index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Dashboard from '@/pages/Dashboard';
import Launcher from '@/pages/Launcher';
import SubmissionsHistory from '@/pages/SubmissionsHistory';
import ViewSubmission from '@/pages/ViewSubmission';
import EditSubmission from '@/pages/EditSubmission';
import PrintPage from '@/pages/PrintPage';
import EmployeesSettings from '@/pages/EmployeesSettings';
import UsersSettings from '@/pages/UsersSettings';
import RolesSettings from '@/pages/RolesSettings';
import ModuleSettings from '@/pages/settings/ModuleSettings';
import DepartmentsSettings from '@/pages/DepartmentsSettings';
import EmailSettings from '@/pages/EmailSettings';
import EmailLog from '@/pages/EmailLog';
import EmailTemplates from '@/pages/EmailTemplates';
import AuditLog from '@/pages/AuditLog';
import BackupSettings from '@/pages/BackupSettings';
import ChangelogPage from '@/pages/ChangelogPage';
import SkuGeneratorPage from '@/pages/shizai/SkuGeneratorPage';
import SkuMasterSettings from '@/pages/settings/SkuMasterSettings';
import StorageSettings from '@/pages/StorageSettings';
import AiLearningSources from '@/pages/AiLearningSources';
import AiSearchStatusPage from '@/pages/settings/AiSearchStatus';
import DocumentProfilesPage from '@/pages/settings/DocumentProfiles';
import DocumentLearningPage from '@/pages/settings/DocumentLearning';
import LearningGuidePage from '@/pages/settings/learning/Guide';
import TerminologyPage from '@/pages/settings/Terminology';
import MaterialsPage from '@/pages/settings/Materials';
import UnknownMaterialsPage from '@/pages/settings/UnknownMaterials';
import RetentionOverviewPage from '@/pages/settings/RetentionOverview';
import PyodideRunner from '@/pages/PyodideRunner';
import LabelDesigner from '@/pages/labels/LabelDesigner';
import LabelTestSheet from '@/pages/labels/LabelTestSheet';
import OrderCategoriesSettings from '@/pages/settings/OrderCategoriesSettings';
import DeliveryDestinationsSettings from '@/pages/settings/DeliveryDestinationsSettings';
import HolidaysSettings from '@/pages/settings/HolidaysSettings';
import ShizaiApprovalsSettings from '@/pages/settings/ShizaiApprovalsSettings';
import ShizaiDelegationsSettings from '@/pages/settings/ShizaiDelegationsSettings';
import LookupsSettings from '@/pages/settings/LookupsSettings';
import ShizaiNotificationsSettings from '@/pages/settings/ShizaiNotificationsSettings';
import AdminNotifySettings from '@/pages/settings/AdminNotifySettings';
import TestModeBanner from '@/components/TestModeBanner';
import MailContainmentBanner from '@/components/MailContainmentBanner';
import DataPrepRemoved from '@/pages/settings/DataPrepRemoved';
import AiPreferencesSettings from '@/pages/settings/AiPreferencesSettings';  // Batch 8
import PreferencesSettings from '@/pages/settings/PreferencesSettings';
import AiConsole from '@/pages/settings/aiconsole/AiConsole';
import TraceabilitySettings from '@/pages/settings/TraceabilitySettings';
import SignatureSettings from '@/pages/SignatureSettings';
import WorkflowSettings from '@/pages/WorkflowSettings';
import VerifySubmission from '@/pages/VerifySubmission';
import Chat from '@/pages/Chat';
import SharedAssistantConversation from '@/pages/SharedAssistantConversation';
import ITLayout from '@/pages/it/ITLayout';
import ITDashboard from '@/pages/it/ITDashboard';
import VlanManagement from '@/pages/it/VlanManagement';
import RequestCenter from '@/pages/it/RequestCenter';
import AssetManagement from '@/pages/it/AssetManagement';
import StaffLedger from '@/pages/it/StaffLedger';
import LicenseManagement from '@/pages/it/LicenseManagement';
import ITDataReport from '@/pages/it/ITDataReport';
import EmailManagement from '@/pages/it/EmailManagement';
import DisposalHistory from '@/pages/it/DisposalHistory';
import ITMembers from '@/pages/it/ITMembers';
import ITMasterSettings from '@/pages/it/ITMasterSettings';
import MyIT from '@/pages/it/MyIT';
import MfgLayout from '@/pages/mfg/MfgLayout';
import AiImportBatches from '@/pages/mfg/AiImportBatches';
import MfgDashboard from '@/pages/mfg/Dashboard';
import Inventory from '@/pages/mfg/Inventory';
import Suppliers from '@/pages/mfg/Suppliers';
import Locations from '@/pages/mfg/Locations';
import StockMoves from '@/pages/mfg/StockMoves';
import Maintenance from '@/pages/mfg/Maintenance';
import Ppe from '@/pages/mfg/Ppe';
import LaborReport from '@/pages/mfg/LaborReport';
import WorkOrders from '@/pages/mfg/WorkOrders';
import MfgShipping from '@/pages/mfg/Shipping';
import ProductionSchedule from '@/pages/mfg/ProductionSchedule';
import MfgKiosk from '@/pages/mfg/MfgKiosk';
import ScannerApp from '@/pages/scanner/ScannerApp';
import POReceiving from '@/pages/scanner/POReceiving';
import Categories from '@/pages/mfg/Categories';
import Uoms from '@/pages/mfg/Uoms';
import MasterData from '@/pages/mfg/MasterData';
import RequestReceiptPrint from '@/pages/shizai/RequestReceiptPrint';
import PicBatchPrint from '@/pages/shizai/PicBatchPrint';
import InvoicePackPrint from '@/pages/shizai/InvoicePackPrint';
import MfgAnalytics from '@/pages/mfg/Analytics';
import ShizaiLayout from '@/pages/shizai/ShizaiLayout';
import ShizaiDashboard from '@/pages/shizai/ShizaiDashboard';
import ShizaiHome from '@/pages/shizai/ShizaiHome';
import Kanban from '@/pages/shizai/Kanban';
import Approvals from '@/pages/shizai/Approvals';
import ApprovalToken from '@/pages/shizai/ApprovalToken';
import Requests from '@/pages/shizai/Requests';
import RequestFormPage from '@/pages/shizai/RequestFormPage';
import ShizaiSettings from '@/pages/shizai/ShizaiSettings';
import ReorderSuggestions from '@/pages/shizai/ReorderSuggestions';
import Orders from '@/pages/shizai/Orders';
import PurchaseHistory from '@/pages/shizai/PurchaseHistory';
import PurchaseRecordAudit from '@/pages/shizai/PurchaseRecordAudit';
import Receiving from '@/pages/shizai/Receiving';
import InvoiceReconciliation from '@/pages/shizai/InvoiceReconciliation';
import PartsRequest from '@/pages/shizai/PartsRequest';
import DocumentDesk from '@/pages/docs/DocumentDesk';
import IngestWorkspacePage from '@/pages/docs/IngestWorkspacePage';
import IngestOpenListPage from '@/pages/docs/IngestOpenListPage';
import DocumentSearchAssistant from '@/pages/docs/DocumentSearchAssistant';
import DocsLayout from '@/pages/docs/DocsLayout';
import ResponsibilityReview from '@/pages/docs/ResponsibilityReview';
import NasArchivePage from '@/pages/docs/nas/NasArchivePage';
import DrawingRevisions from '@/pages/docs/DrawingRevisions';
import SharesList from '@/pages/docs/SharesList';
import PublicShare from '@/pages/share/PublicShare';
import EngineeringLayout from '@/pages/engineering/EngineeringLayout';
import EngAssets from '@/pages/engineering/EngAssets';
import EngMembers from '@/pages/engineering/EngMembers';
import EngFabrication from '@/pages/engineering/EngFabrication';
import EngForms from '@/pages/engineering/EngForms';
import EngFormBuilder from '@/pages/engineering/EngFormBuilder';
import EngFormFill from '@/pages/engineering/EngFormFill';
import EngFormResponses from '@/pages/engineering/EngFormResponses';
import EngReports from '@/pages/engineering/EngReports';
import EngReportForm from '@/pages/engineering/EngReportForm';
import EngReportDashboard from '@/pages/engineering/EngReportDashboard';
import EngReportDigests from '@/pages/engineering/EngReportDigests';
import EngShelves from '@/pages/engineering/EngShelves';
import EngTaxonomy from '@/pages/engineering/EngTaxonomy';
import EngKbExport from '@/pages/engineering/EngKbExport';
import EngAiFeedback from '@/pages/engineering/EngAiFeedback';
import EngAiDigest from '@/pages/engineering/EngAiDigest';
import QrShortLink, { LegacyAssetOpenRedirect } from '@/pages/engineering/QrShortLink';
import DevDashboard from '@/pages/engineering/development/DevDashboard';
import DevList from '@/pages/engineering/development/DevList';
import DevGuide from '@/pages/engineering/development/DevGuide';
import DevCreate from '@/pages/engineering/development/DevCreate';
import DevDetail from '@/pages/engineering/development/DevDetail';
import DevPrint from '@/pages/engineering/development/DevPrint';
import HandoverPrint from '@/pages/engineering/development/HandoverPrint';
import PrototypeDetail from '@/pages/engineering/development/PrototypeDetail';
import ReadinessSnapshot from '@/pages/engineering/development/ReadinessSnapshot';
import DevInsights from '@/pages/engineering/development/Insights';
import DevAnalytics from '@/pages/engineering/development/Analytics';
import DevLearningDigest from '@/pages/engineering/development/LearningDigest';
import DevCostAnalytics from '@/pages/engineering/development/CostAnalytics';
import OrderPrint from '@/pages/shizai/OrderPrint';
import MarketingLayout from '@/pages/marketing/MarketingLayout';
import MktOrders from '@/pages/marketing/Orders';
import MktOrderDetail from '@/pages/marketing/OrderDetail';
import MktCustomers from '@/pages/marketing/Customers';
import MktSettings from '@/pages/marketing/MarketingSettings';
import MktDashboard from '@/pages/marketing/Dashboard';
import MktDocPrint from '@/pages/marketing/DocPrint';
import MktBilling from '@/pages/marketing/Billing';
import DemoPage from '@/pages/demo/Demo';
import PlannerLayout from '@/pages/planner/PlannerLayout';
import PlannerHome from '@/pages/planner/PlannerHome';
import DepartmentDashboard from '@/pages/planner/DepartmentDashboard';
import ProjectBoard from '@/pages/planner/ProjectBoard';
import MyTasks from '@/pages/planner/MyTasks';
import MyProjects from '@/pages/planner/MyProjects';
import PublicGantt from '@/pages/planner/PublicGantt';
import SharedBundleView from '@/pages/docs/SharedBundleView';
import PlannerDigest from '@/pages/planner/PlannerDigest';
import ArchiveReview from '@/pages/planner/ArchiveReview';
import ArchivedOldProjects from '@/pages/planner/ArchivedOldProjects';
import ErrorBoundary from '@/components/ErrorBoundary';
import ProjectRedirect from '@/pages/planner/ProjectRedirect';
import KnowledgeLayout from '@/pages/knowledge/KnowledgeLayout';
import BihinLayout from '@/pages/bihin/BihinLayout';
import BihinDashboard from '@/pages/bihin/BihinDashboard';
import BihinItems from '@/pages/bihin/BihinItems';
import KnowledgeHome from '@/pages/knowledge/KnowledgeHome';
import ArticleView from '@/pages/knowledge/ArticleView';
import ArticleEditor from '@/pages/knowledge/ArticleEditor';
import Login from '@/pages/Login';
import ChangePassword from '@/pages/ChangePassword';
import CredentialsPrint from '@/pages/CredentialsPrint';
import I18nReport from '@/pages/I18nReport';
import Layout from '@/components/Layout';
import SettingsLayout from '@/components/SettingsLayout';
import { AuthProvider, canManageEmployees, canManageLabels, canBackup, canAdvancedSettings, canManageSku, canAiImportHistory, canViewAiLogs, isAdmin, isManager, useAuth, isSimpleMenu } from '@/auth/AuthContext';
import EquipmentHub from '@/pages/hubs/EquipmentHub';
import RentalsHub from '@/pages/hubs/RentalsHub';
import FloormapHub from '@/pages/hubs/FloormapHub';
import BomHub from '@/pages/hubs/BomHub';
import AiOperationLogs from '@/pages/settings/aiops/AiOperationLogs';
import AiOperationDetail from '@/pages/settings/aiops/AiOperationDetail';
import ChatFab from '@/components/ChatFab';
import TranslationPrewarm from '@/components/TranslationPrewarm';
import GlobalDropGuard from '@/components/GlobalDropGuard';
import { RequireAuth, RequireAdmin, RequireSettingsAccess, RequireCapability, RequireApp, SettingsIndexRedirect } from '@/auth/Protected';

/**
 * シンプルメニュー（既定 ON）のときだけ、古い URL を 設定 → マスター へ送る。
 * OFF のときは今までの画面をそのまま出す（戻せる状態を残す）。
 */
function MasterRedirect({ to, children }) {
  const { user } = useAuth();
  return isSimpleMenu(user) ? <Navigate to={to} replace /> : children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <TestModeBanner />
          <MailContainmentBanner />
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />
            {/* Hidden developer page — lists JA UI phrases missing an English translation. */}
            <Route path="/i18n-report" element={<I18nReport />} />
            {/* Public magic-link approval landing — no auth required, token in URL is the auth */}
            <Route path="/shizai/approvals/token/:token" element={<ApprovalToken />} />
            {/* Public read-only Gantt share — token in URL is the auth */}
            <Route path="/g/:token" element={<PublicGantt />} />
            {/* Public read-only bundle share — token in URL is the auth */}
            <Route path="/b/:token" element={<SharedBundleView />} />
            {/* Public password-protected document share — token in URL + password */}
            <Route path="/s/:token" element={<PublicShare />} />

            {/* iter_143f · /mfg/master moved into 設定 → 生産マスター. Kept as a
                redirect ABOVE the /mfg wrapper so the department picker
                doesn't intercept it. */}
            <Route path="/mfg/master" element={<Navigate to="/settings/mfg-master" replace />} />

            {/* iter_143h · 発注依頼書 print view — full-screen A4 receipt
                for a shizai_request. Rendered OUTSIDE the app chrome so the
                new-tab print target is clean. Any authenticated user can
                open it; the component itself does the ownership/access
                check against /shizai/requests/{id} + /my-requests/{id}. */}
            <Route path="/shizai/requests/:id/print" element={<RequireAuth><RequestReceiptPrint /></RequireAuth>} />
            {/* PIC まとめて印刷 — one A4 sheet per request, ids via query */}
            <Route path="/shizai/requests-print-batch" element={<RequireAuth><PicBatchPrint /></RequireAuth>} />
            <Route path="/shizai/invoice-pack" element={<RequireAuth><InvoicePackPrint /></RequireAuth>} />

            {/* Authenticated — full-screen (no app chrome) */}
            <Route path="/change-password" element={<RequireAuth><ChangePassword /></RequireAuth>} />
            <Route path="/settings/credentials-print" element={<RequireAuth><RequireAdmin><CredentialsPrint /></RequireAdmin></RequireAuth>} />

            {/* Authenticated */}
            <Route path="/" element={<RequireAuth><Launcher /></RequireAuth>} />
            <Route path="/shizai/orders/:id/print" element={<RequireAuth><RequireApp app="shizai"><OrderPrint /></RequireApp></RequireAuth>} />
            {/* 営業受注 · 見積書/請求書 print view — full-screen A4, outside app chrome */}
            <Route path="/marketing/print/:docId" element={<RequireAuth><RequireApp app="marketing"><MktDocPrint /></RequireApp></RequireAuth>} />
            <Route path="/mfg/kiosk" element={<RequireAuth><RequireApp app="mfg"><MfgKiosk /></RequireApp></RequireAuth>} />
            <Route path="/f/:fid" element={<RequireAuth><EngFormFill standalone /></RequireAuth>} />
            {/* ラベルQRの短縮リンク /q/a/{id}=技術資産 /q/e/{id}=設備台帳。認証は
                リダイレクト先で行う（RequireAuth が next を保持する）。 */}
            <Route path="/q/:kind/:id" element={<QrShortLink />} />
            <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
              <Route path="forms" element={<RequireApp app="kintai"><Dashboard /></RequireApp>} />
              <Route path="history" element={<RequireApp app="kintai"><SubmissionsHistory /></RequireApp>} />
              <Route path="chat" element={<RequireApp app="chat"><Chat /></RequireApp>} />
              <Route path="assistant/shared/:token" element={<RequireApp app="chat"><SharedAssistantConversation /></RequireApp>} />
              {/* UX consolidation (2026-06): the code interpreter is a 設定 tool,
                  not a separate AI application. /ai/code redirects. */}
              <Route path="ai/code" element={<Navigate to="/settings/ai-code" replace />} />
              {/* マイIT — self-service view, open to ALL users (outside the
                  IT-staff-only /it app). Shows only the caller's own resources. */}
              <Route path="my-it" element={<div className="max-w-5xl mx-auto"><MyIT /></div>} />
              <Route path="it" element={<RequireApp app="it"><ITLayout /></RequireApp>}>
                <Route index element={<ITDashboard />} />
                <Route path="my" element={<MyIT />} />
                <Route path="vlan" element={<VlanManagement />} />
                <Route path="assets" element={<AssetManagement />} />
                <Route path="floormap" element={<FloormapHub side="it" />} />
                <Route path="staff" element={<StaffLedger />} />
                <Route path="licenses" element={<LicenseManagement />} />
                <Route path="emails" element={<EmailManagement />} />
                <Route path="requests" element={<RequestCenter />} />
                <Route path="disposals" element={<DisposalHistory />} />
                <Route path="data-report" element={<ITDataReport />} />
                <Route path="members" element={<Navigate to="/settings/it-members" replace />} />
              </Route>
              <Route path="mfg" element={<RequireApp app="mfg"><MfgLayout /></RequireApp>}>
                <Route index element={<MfgDashboard />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="work-orders" element={<WorkOrders />} />
                <Route path="shipping" element={<MfgShipping />} />
                <Route path="schedule" element={<ProductionSchedule />} />
                <Route path="analytics" element={<MfgAnalytics />} />
                <Route path="bom" element={<BomHub side="tree" />} />
                <Route path="boms" element={<BomHub side="list" />} />
                <Route path="labor" element={<LaborReport />} />
                <Route path="equipment" element={<EquipmentHub side="mfg" />} />
                <Route path="maintenance" element={<Maintenance />} />
                <Route path="ppe" element={<Ppe />} />
                <Route path="suppliers" element={<Suppliers />} />
                <Route path="categories" element={<MasterRedirect to="/settings/taxonomy"><Categories /></MasterRedirect>} />
                <Route path="uoms" element={<Uoms />} />
                <Route path="locations" element={<MasterRedirect to="/settings/locations"><Locations /></MasterRedirect>} />
                <Route path="moves" element={<StockMoves />} />
              </Route>
              <Route path="shizai" element={<RequireApp app="shizai"><ShizaiLayout /></RequireApp>}>
                <Route index element={<ShizaiHome />} />
                <Route path="kanban" element={<Kanban />} />
                <Route path="approvals" element={<Approvals />} />
                <Route path="dashboard" element={<ShizaiDashboard />} />
                <Route path="requests" element={<Requests />} />
                <Route path="requests/new" element={<RequestFormPage />} />
                <Route path="requests/:id/edit" element={<RequestFormPage />} />
                <Route path="settings" element={<ShizaiSettings />} />
                <Route path="reorder" element={<ReorderSuggestions />} />
                <Route path="orders" element={<Orders />} />
                <Route path="suppliers" element={<Suppliers />} />
                <Route path="history" element={<PurchaseHistory />} />
                <Route path="purchase-records" element={<Navigate to="/settings/data-audit" replace />} />
                <Route path="receiving" element={<Receiving />} />
                <Route path="invoices" element={<InvoiceReconciliation />} />
                <Route path="sku-generator" element={<SkuGeneratorPage />} />
              </Route>
              <Route path="parts-request" element={<RequireApp app="parts_request"><PartsRequest /></RequireApp>} />
              <Route path="documents" element={<RequireApp app="docs"><DocsLayout /></RequireApp>}>
                <Route index element={<DocumentDesk />} />
                {/* Beta-3 · 書類検索アシスタント — a feature of ドキュメント, not a separate app */}
                <Route path="assistant" element={<DocumentSearchAssistant />} />
                {/* HT-4.5 · 責任者の一括確認 — 既存の確認APIだけを使う作業画面 */}
                <Route path="responsibilities" element={<ResponsibilityReview />} />
                <Route path="ingest" element={<IngestOpenListPage />} />
                <Route path="ingest/:batchId" element={<IngestWorkspacePage />} />
                {/* NAS Archive — independent feature, isolated from すべての書類 */}
                <Route path="nas" element={<NasArchivePage />} />
                {/* スマート版管理 — 同じ図番の版をまとめて最新版を判定する */}
                <Route path="drawing-revisions" element={<DrawingRevisions />} />
              <Route path="shares" element={<SharesList />} />
              </Route>
              {/* Retired route — kept so bookmarks keep working */}
              <Route path="assistant/documents" element={<Navigate to="/documents/assistant" replace />} />
              <Route path="engineering" element={<RequireApp app="engineering"><EngineeringLayout /></RequireApp>}>
                <Route index element={<LegacyAssetOpenRedirect><DevDashboard /></LegacyAssetOpenRedirect>} />
                <Route path="assets" element={<EngAssets />} />
                <Route path="developments" element={<DevList />} />
                <Route path="developments/new" element={<DevCreate />} />
                <Route path="developments/guide" element={<DevGuide />} />
                <Route path="developments/:id" element={<DevDetail />} />
                <Route path="developments/:id/prototypes/:pid" element={<PrototypeDetail />} />
                <Route path="developments/readiness" element={<ReadinessSnapshot />} />
                <Route path="developments/insights" element={<DevInsights />} />
                <Route path="developments/analytics" element={<DevAnalytics />} />
                <Route path="developments/learning" element={<DevLearningDigest />} />
                <Route path="developments/cost" element={<DevCostAnalytics />} />
                <Route path="developments/:id/print" element={<DevPrint />} />
                <Route path="developments/:id/handover" element={<HandoverPrint />} />
                <Route path="equipment" element={<EquipmentHub side="eng" />} />
                <Route path="fabrication" element={<EngFabrication />} />
                <Route path="rentals" element={<RentalsHub side="eng" />} />
                <Route path="forms" element={<EngForms />} />
                <Route path="forms/new" element={<EngFormBuilder />} />
                <Route path="forms/:fid/edit" element={<EngFormBuilder />} />
                <Route path="forms/:fid/fill" element={<EngFormFill />} />
                <Route path="forms/:fid/responses" element={<EngFormResponses />} />
                <Route path="reports" element={<EngReports />} />
                <Route path="reports/new" element={<EngReportForm />} />
                <Route path="reports/dashboard" element={<EngReportDashboard />} />
                <Route path="reports/digests" element={<EngReportDigests />} />
                <Route path="ai-digest" element={<EngAiDigest />} />
                <Route path="ai-feedback" element={<EngAiFeedback />} />
                <Route path="reports/:rid" element={<EngReportForm />} />
                <Route path="shelves" element={<MasterRedirect to="/settings/locations"><RequireAdmin redirectTo="/engineering"><EngShelves /></RequireAdmin></MasterRedirect>} />
                <Route path="taxonomy" element={<MasterRedirect to="/settings/taxonomy"><RequireAdmin redirectTo="/engineering"><EngTaxonomy /></RequireAdmin></MasterRedirect>} />
                <Route path="kb-export" element={<EngKbExport />} />
                <Route path="members" element={<Navigate to="/settings/eng-members" replace />} />
                <Route path="*" element={<Navigate to="/engineering" replace />} />
              </Route>
              <Route path="bihin" element={<RequireApp app="bihin"><BihinLayout /></RequireApp>}>
                <Route index element={<BihinDashboard />} />
                <Route path="items" element={<BihinItems />} />
                <Route path="loans" element={<RentalsHub side="bihin" />} />
                <Route path="floormap" element={<FloormapHub side="bihin" />} />
              </Route>
              {/* 全社デモモード — 営業アプリから昇格したグローバル機能 */}
              <Route path="demo" element={<DemoPage />} />
              <Route path="marketing" element={<RequireApp app="marketing"><MarketingLayout /></RequireApp>}>
                <Route index element={<MktDashboard />} />
                <Route path="orders" element={<MktOrders />} />
                <Route path="orders/:id" element={<MktOrderDetail />} />
                <Route path="customers" element={<MktCustomers />} />
                <Route path="billing" element={<MktBilling />} />
                <Route path="demo" element={<Navigate to="/demo" replace />} />
                <Route path="settings" element={<MktSettings />} />
              </Route>
              <Route path="planner" element={<RequireApp app="planner"><PlannerLayout /></RequireApp>}>
                <Route index element={<PlannerHome />} />
                <Route path="my-tasks" element={<MyTasks />} />
                <Route path="my-projects" element={<MyProjects />} />
                <Route path="digest" element={<PlannerDigest />} />
                <Route path="archive-review" element={<ArchiveReview />} />
                <Route path="old-projects" element={<ArchivedOldProjects />} />
                <Route path="dept/:deptId" element={<DepartmentDashboard />} />
                <Route path="project/:projectId" element={<ErrorBoundary backTo="/planner" backLabel="プロジェクト一覧に戻る"><ProjectBoard /></ErrorBoundary>} />
                {/* 旧リンク互換: /planner/projects/:projectId → /planner/project/:projectId */}
                <Route path="projects/:projectId" element={<ProjectRedirect />} />
              </Route>
              <Route path="knowledge" element={<RequireApp app="knowledge"><KnowledgeLayout /></RequireApp>}>
                <Route index element={<KnowledgeHome />} />
                <Route path="p/:id" element={<ArticleView />} />
                <Route path="p/:id/edit" element={<ArticleEditor />} />
              </Route>
              <Route path="scanner" element={<RequireApp app="scanner"><ScannerApp /></RequireApp>} />
              <Route path="scanner/po-receive" element={<RequireApp app="scanner"><POReceiving /></RequireApp>} />
              <Route path="submission/:id" element={<RequireApp app="kintai"><ViewSubmission /></RequireApp>} />
              <Route path="submission/:id/edit" element={<RequireApp app="kintai"><EditSubmission /></RequireApp>} />
              <Route path="verify/:id" element={<RequireApp app="kintai"><VerifySubmission /></RequireApp>} />
              <Route path="print" element={<RequireApp app="kintai"><PrintPage /></RequireApp>} />
              {/* Settings — admin gets all sub-routes; manager only sees employees/departments */}
              <Route path="settings" element={<RequireApp app="settings"><RequireSettingsAccess><SettingsLayout /></RequireSettingsAccess></RequireApp>}>
                <Route index element={<SettingsIndexRedirect />} />
                <Route path="employees" element={<RequireCapability allowed={canManageEmployees} redirectTo="/settings/signature"><EmployeesSettings /></RequireCapability>} />
                <Route path="departments" element={<DepartmentsSettings />} />
                <Route path="signature" element={<SignatureSettings />} />
                <Route path="ai-preferences" element={<AiPreferencesSettings />} />
                <Route path="preferences" element={<PreferencesSettings />} />
                <Route path="ai-console" element={<AiConsole />} />
                <Route path="ai-operations" element={<RequireCapability allowed={canViewAiLogs} redirectTo="/settings/ai-console"><AiOperationLogs /></RequireCapability>} />
                <Route path="ai-operations/:operationId" element={<RequireCapability allowed={canViewAiLogs} redirectTo="/settings/ai-console"><AiOperationDetail /></RequireCapability>} />
                <Route path="workflow" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/signature"><WorkflowSettings /></RequireCapability>} />
                {/* Admin-only sub-routes — managers get redirected to a page they can see */}
                <Route path="users" element={<RequireAdmin redirectTo="/settings/employees"><UsersSettings /></RequireAdmin>} />
                <Route path="roles" element={<RequireAdmin redirectTo="/settings/employees"><RolesSettings /></RequireAdmin>} />
                <Route path="eng-members" element={<RequireAdmin redirectTo="/settings/employees"><EngMembers /></RequireAdmin>} />
                <Route path="it-members" element={<RequireAdmin redirectTo="/settings/employees"><ITMembers /></RequireAdmin>} />
                <Route path="it-categories" element={<RequireAdmin redirectTo="/settings/employees"><ITMasterSettings /></RequireAdmin>} />
                <Route path="eng-shelves" element={<RequireAdmin redirectTo="/settings/employees"><EngShelves /></RequireAdmin>} />
                <Route path="locations" element={<RequireAdmin redirectTo="/settings/employees"><EngShelves /></RequireAdmin>} />
                <Route path="taxonomy" element={<RequireAdmin redirectTo="/settings/employees"><EngTaxonomy /></RequireAdmin>} />
                <Route path="modules" element={<RequireAdmin redirectTo="/settings/employees"><ModuleSettings /></RequireAdmin>} />
                <Route path="traceability" element={<RequireAdmin redirectTo="/settings/employees"><TraceabilitySettings /></RequireAdmin>} />
                <Route path="email" element={<RequireAdmin redirectTo="/settings/employees"><EmailSettings /></RequireAdmin>} />
                <Route path="email-templates" element={<RequireAdmin redirectTo="/settings/employees"><EmailTemplates /></RequireAdmin>} />
                <Route path="email-log" element={<RequireAdmin redirectTo="/settings/employees"><EmailLog /></RequireAdmin>} />
                <Route path="audit-log" element={<RequireAdmin redirectTo="/settings/employees"><AuditLog /></RequireAdmin>} />
                <Route path="backup" element={<RequireCapability allowed={canBackup} redirectTo="/settings/employees"><BackupSettings /></RequireCapability>} />
                <Route path="changelog" element={<ChangelogPage />} />
                <Route path="storage" element={<RequireAdmin redirectTo="/settings/employees"><StorageSettings /></RequireAdmin>} />
                <Route path="ai-learning" element={<RequireAdmin redirectTo="/settings/employees"><AiLearningSources /></RequireAdmin>} />
                <Route path="ai-search-status" element={<RequireAdmin redirectTo="/settings/employees"><AiSearchStatusPage /></RequireAdmin>} />
                <Route path="doc-profiles" element={<RequireAdmin redirectTo="/settings/employees"><DocumentProfilesPage /></RequireAdmin>} />
                <Route path="doc-learning" element={<RequireAdmin redirectTo="/settings/employees"><DocumentLearningPage /></RequireAdmin>} />
                <Route path="doc-learning/guide" element={<RequireAdmin redirectTo="/settings/employees"><LearningGuidePage /></RequireAdmin>} />
                <Route path="document-learning" element={<RequireAdmin redirectTo="/settings/employees"><DocumentLearningPage /></RequireAdmin>} />
                <Route path="document-learning/guide" element={<RequireAdmin redirectTo="/settings/employees"><LearningGuidePage /></RequireAdmin>} />
                <Route path="terminology" element={<RequireAdmin redirectTo="/settings/employees"><TerminologyPage /></RequireAdmin>} />
                <Route path="materials" element={<RequireAdmin redirectTo="/settings/employees"><MaterialsPage /></RequireAdmin>} />
                <Route path="materials/unknown" element={<RequireAdmin redirectTo="/settings/employees"><UnknownMaterialsPage /></RequireAdmin>} />
                <Route path="retention" element={<RequireAdmin redirectTo="/settings/employees"><RetentionOverviewPage /></RequireAdmin>} />
                <Route path="ai-import-history" element={<RequireCapability allowed={canAiImportHistory} redirectTo="/settings/signature"><AiImportBatches /></RequireCapability>} />
                <Route path="ai-code" element={<RequireAdmin redirectTo="/settings/employees"><PyodideRunner /></RequireAdmin>} />
                <Route path="labels" element={<RequireCapability allowed={canManageLabels} redirectTo="/settings/employees"><LabelDesigner /></RequireCapability>} />
                <Route path="labels/test-sheet" element={<RequireCapability allowed={canManageLabels} redirectTo="/settings/employees"><LabelTestSheet /></RequireCapability>} />
                <Route path="order-categories" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><OrderCategoriesSettings /></RequireCapability>} />
                <Route path="delivery-destinations" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><DeliveryDestinationsSettings /></RequireCapability>} />
                <Route path="holidays" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><HolidaysSettings /></RequireCapability>} />
                {/* 2026-10-21 · 本番運用開始につき削除。設定へ戻す。 */}
                <Route path="data-prep" element={<DataPrepRemoved />} />
                {/* R1 · データ点検 → 購入記録。資材モジュールを止めていても開ける。 */}
                <Route path="data-audit" element={<RequireAdmin redirectTo="/settings/employees"><PurchaseRecordAudit /></RequireAdmin>} />
                <Route path="data-audit/purchase-records" element={<Navigate to="/settings/data-audit" replace />} />
                <Route path="sku-master" element={<RequireCapability allowed={canManageSku} redirectTo="/settings/employees"><SkuMasterSettings /></RequireCapability>} />
                <Route path="sku-templates" element={<Navigate to="/settings/sku-master" replace />} />
                {/* iter_143f · 製造/資材 マスター管理 was moved into 設定 → マスター
                    per user 20260722. All 6 sub-masters (仕入先/場所/作業拠点/カテゴリ/単位/メーカー)
                    live inside MasterData's tabbed UI. */}
                <Route path="mfg-master" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><MasterData /></RequireCapability>} />
                <Route path="shizai-approvals" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><ShizaiApprovalsSettings /></RequireCapability>} />
                <Route path="shizai-delegations" element={<ShizaiDelegationsSettings />} />
                <Route path="lookups" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><LookupsSettings /></RequireCapability>} />
                <Route path="shizai-notifications" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><ShizaiNotificationsSettings /></RequireCapability>} />
                <Route path="admin-notify" element={<RequireCapability allowed={canAdvancedSettings} redirectTo="/settings/employees"><AdminNotifySettings /></RequireCapability>} />
                <Route path="*" element={<SettingsIndexRedirect />} />
              </Route>
            </Route>
            {/* 不明なURLは真っ白な画面にせずランチャーへ戻す */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <ChatFab />
          <TranslationPrewarm />
          <GlobalDropGuard />
        </AuthProvider>
      </BrowserRouter>
      {/* ヘッダー（h-16）とドロワーのタイトルに被らない位置。×で閉じられる。 */}
      <Toaster position="top-right" richColors closeButton offset={76} />
    </div>
  );
}

export default App;
